// styles
import styles from "./SizeProtestSection.module.scss";

// components
// component
import { Icon } from "@trussworks/react-uswds";
import {
  Dialog,
  DialogContent,
  DialogClose,
  IconButton,
  Button,
} from "components/LibraryComponents/Components";

type ConfirmationDialogProps = {
  open: boolean;
  isLoading: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleClick: () => void;
};

export default function ConfirmationDialog(props: ConfirmationDialogProps) {
  return (
    <Dialog open={props.open} onOpenChange={props.setOpen}>
      <DialogContent
        className={styles["confirmation-dialog-root"]}
        hasBackdrop
        lockScroll
      >
        <div className={styles["confirmation-dialog-body"]}>
          <div className={styles["header"]}>
            <IconButton
              type="button"
              Icon={<Icon.Close />}
              size="sm"
              onClick={() => props.setOpen(false)}
              tabIndex={-1}
              aria-label="Close dialog"
            />
          </div>

          <div className={styles["confirmation-content"]}>
            <p className={styles["title"]}>
              Are you sure you want to remove the size protest?
            </p>
            <p className={styles["desc"]}>
              This will delete the data in the SBA Formal Size Determinations
              area. A record of the size protest will be logged in this
              business’s Activity Log page.
            </p>
          </div>
        </div>

        <div className={styles["confirmation-dialog-footer"]}>
          <Button
            type="button"
            className={styles["btn-submit"]}
            loading={props.isLoading}
            disabled={props.isLoading}
            onClick={props.handleClick}
          >
            {props.isLoading ? "Removing..." : "Remove the size protest"}
          </Button>

          <DialogClose className={styles["btn-close"]}>
            Cancel removal
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
}
